exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reported-comm{margin-top:0}.reported-comm .aline{margin:0 6px;color:#ddd;font-size:12px;vertical-align:top}.reported-comm .row-group a:hover{text-decoration:none}.reported-comm .pop .status-form{font-size:16px;text-align:center;margin-top:-20px}.reported-comm .pop .status-form .form-cont h2{font-size:22px;font-weight:700;margin-bottom:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/community/reported-post/reported-post.scss
// module id = 521
// module chunks = 2